<page-heading
  [title]="
    isNew ? ('integrations.santriForm.pageTitleNew' | translate) : ('integrations.santriForm.pageTitleEdit' | translate)
  "
  [description]="
    isNew
      ? ('integrations.santriForm.pageDescriptionNew' | translate)
      : ('integrations.santriForm.pageDescriptionEdit' | translate)
  "
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

@if (loadingContent) {
<content-loading-list />
}

<div class="card">
  <div class="card-body py-3">
    <div class="row g-2 align-items-center justify-content-between">
      <div class="col-12 col-lg-6">
        <div class="d-flex align-items-center gap-2">
          <span class="fw-semibold text-nowrap">{{ 'integrations.santriForm.webhookUrlLabel' | translate }}</span>
          <span
            class="text-muted small text-truncate"
            style="min-width: 0; max-width: 100%"
            [attr.title]="webhookIntegrations?.url"
          >
            {{ webhookIntegrations.url }}
          </span>

          <button
            type="button"
            class="btn btn-link p-0 ms-1"
            id="copyIcon"
            (click)="copyUrl()"
            [attr.aria-label]="'integrations.santriForm.copyUrlAriaLabel' | translate"
            [attr.title]="'integrations.santriForm.copyUrlTitle' | translate"
          >
            <i class="bi bi-clipboard fs-5"></i>
          </button>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div
          class="d-flex align-items-center justify-content-lg-end mt-2 mt-lg-0 gap-3"
        >
          @if(isAdmin()) {
          <div class="custom-switch col-8 col-md-6">
            <input
              type="checkbox"
              id="webhookStatus"
              data-switch="success"
              [(ngModel)]="isActive"
              (change)="toggleWebhookStatus()"
            />
            <label for="webhookStatus">
              <span>
                <p class="text-muted">
                  {{ 'integrations.santriForm.webhookStatusPrefix' | translate }} {{ isActive ? "" : ('integrations.santriForm.webhookStatusConnector' | translate) }}
                  <strong
                    class="text-nowrap"
                    [ngClass]="{
                      'text-success': isActive,
                      'text-dark': !isActive
                    }"
                  >
                    {{ isActive ? ('integrations.santriForm.webhookStatusWorking' | translate) : ('integrations.santriForm.webhookStatusTestMode' | translate) }}
                  </strong>
                </p>
              </span>
            </label>
          </div>
          }
          <button
            type="button"
            class="btn btn-primary text-nowrap col-auto"
            (click)="view(webhooks[0])"
          >
            {{ 'integrations.santriForm.showCurlButton' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card" [ngStyle]="{ opacity: isActive ? '0.2' : '1' }">
  <form [formGroup]="formGroup">
    <div class="row">
      <div class="col-xs-12">
        <div class="row">
          <div class="card-body">
            <div class="row">
              <div class="col-xs-12 col-xl-8 mb-3">
                <label class="form-label">{{ 'integrations.santriForm.nameLabel' | translate }}</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="100"
                  formControlName="name"
                  [placeholder]="'integrations.santriForm.namePlaceholder' | translate"
                  required="isActive"
                />
                <field-error-component
                  [field]="'name'"
                  [label]="'integrations.fields.name' | translate"
                  [formGroup]="formGroup"
                />
              </div>
              <div class="col-xs-12 col-xl-4 mb-3">
                <label class="form-label">{{ 'integrations.santriForm.channelLabel' | translate }}</label>
                <mat-select
                  class="form-control"
                  formControlName="channel"
                  [placeholder]="'integrations.santriForm.channelPlaceholder' | translate"
                  required="isActive"
                >
                  @for(channel of channels; track channel ) {
                  <mat-option
                    [value]="channel._id"
                    (click)="changeChannelDialog(channel._id)"
                  >
                    {{ channel.name }}
                  </mat-option>
                  }
                </mat-select>
                <field-error-component
                  [field]="'channel'"
                  [label]="'integrations.fields.model' | translate"
                  [formGroup]="formGroup"
                ></field-error-component>
              </div>
            </div>

            <!-- DEV-1992 — the inbound payload carries the PIX code and nothing else, so the payee
                 Meta requires alongside it is configured here, once per integration. -->
            @if (showPixSection) {
            <div class="row">
              <div class="col-12 mb-3">
                <div class="card border">
                  <div class="card-body">
                    <h5 class="header-title mb-1">{{ 'integrations.santriForm.pixTitle' | translate }}</h5>
                    <p class="text-muted font-13 mb-3">{{ 'integrations.santriForm.pixDescription' | translate }}</p>
                    <div class="row">
                      <div class="col-xs-12 col-xl-6 mb-3">
                        <label class="form-label" for="pix-merchant-name">
                          {{ 'integrations.santriForm.pixMerchantNameLabel' | translate }}
                        </label>
                        <input id="pix-merchant-name" type="text" class="form-control" maxlength="100"
                          formControlName="pixMerchantName"
                          [placeholder]="'integrations.santriForm.pixMerchantNamePlaceholder' | translate" />
                      </div>
                      <div class="col-xs-12 col-xl-2 mb-3">
                        <label class="form-label" for="pix-key-type">
                          {{ 'integrations.santriForm.pixKeyTypeLabel' | translate }}
                        </label>
                        <mat-select id="pix-key-type" class="form-control" formControlName="pixKeyType">
                          @for (keyType of pixKeyTypes; track keyType) {
                          <mat-option [value]="keyType">{{ keyType }}</mat-option>
                          }
                        </mat-select>
                      </div>
                      <div class="col-xs-12 col-xl-4 mb-3">
                        <label class="form-label" for="pix-key">
                          {{ 'integrations.santriForm.pixKeyLabel' | translate }}
                        </label>
                        <input id="pix-key" type="text" class="form-control" maxlength="100" formControlName="pixKey"
                          [placeholder]="'integrations.santriForm.pixKeyPlaceholder' | translate" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }

            @if(selectedChannel) {
            <div class="row">
              <div class="col-xs-12 col-lg-3 mb-3">
                <div class="card h-100">
                  <div class="card-body">
                    <div class="row">
                      <h4 class="text-dark mb-2">{{ 'integrations.santriForm.requestsTitle' | translate }}</h4>
                      <p class="text-muted">
                        {{ 'integrations.santriForm.requestsDescription' | translate }}
                      </p>
                      <div class="custom-switch col-12 mb-3">
                        <input
                          type="checkbox"
                          id="requestType"
                          checked
                          data-switch="success"
                          formControlName="requestType"
                        />
                        <label for="requestType">
                          <span value="DEFAULT">{{ 'integrations.santriForm.requestTypeDefault' | translate }}</span>
                        </label>
                      </div>
                      <div class="col-xs-12 mb-3">
                        <div class="d-flex align-items-center gap-2">
                          <mat-select
                            class="form-control"
                            formControlName="tags"
                            [placeholder]="'integrations.santriForm.requestSelectPlaceholder' | translate"
                            required="isActive"
                          >
                            @for(request of webhooks; track $index ) {
                            <mat-option
                              [value]="request._id"
                              (click)="webhookRequestSelected($index)"
                            >
                              {{ $index + 1 }}
                            </mat-option>
                            }
                          </mat-select>

                          <div class="d-flex align-items-center">
                            <i
                              class="me-2 mt-1 cursor-pointer"
                              [ngClass]="
                                loading
                                  ? 'spinner-border'
                                  : 'bi bi-arrow-repeat fs-2'
                              "
                              [ngStyle]="
                                loading
                                  ? { 'width.px': 18, 'height.px': 18 }
                                  : null
                              "
                              role="status"
                              aria-hidden="true"
                              (click)="isActive ? null : getWebhookRequests()"
                            ></i>
                          </div>
                        </div>
                      </div>
                      @if(webhookRequests) {
                      <div class="col-12">
                        <div class="border rounded-3 p-2 overflow-auto">
                          @for (request of webhookRequests | keyvalue; track
                          $index) {
                          <div class="d-flex mb-2">
                            <span class="fw-bold text-dark me-1"
                              >{{ request.key | lowercase }}:</span
                            >
                            <span class="text-break">{{ request.value }}</span>
                          </div>
                          }
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-lg-9">
                <div class="card">
                  <div class="card-body">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <h4 class="fw-bold text-dark" style="font-size: 20px">
                        {{ 'integrations.santriForm.actionsTitle' | translate }}
                        <sup>
                          <small class="text-muted"> {{ items.length }}</small>
                        </sup>
                      </h4>
                      <div
                        class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button"
                      >
                        <button
                          type="button"
                          class="btn btn-primary fw-bold dropdown-toggle"
                          [matMenuTriggerFor]="newActionsType"
                          [disabled]="this.isActive"
                        >
                          {{ 'integrations.santriForm.addActionsButton' | translate }}
                        </button>
                        <mat-menu #newActionsType="matMenu">
                          @for (action of actionsType; track $index) {
                          <button mat-menu-item (click)="addComponent(action)">
                            {{ getActionTypeLabel(action) }}
                          </button>
                          }
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12">
                  @for(item of items.controls; track $index) {
                  <div class="form-group">
                    <santri-integrations-item-component
                      [itemForm]="getItemForm($index)"
                      [index]="$index"
                      [channel]="selectedChannel"
                      [webhookRequests]="webhookRequests"
                      [webhookIntegrations]="webhookIntegrations"
                      (remove)="deleteComponent($event)"
                      [isActive]="isActive"
                    >
                    </santri-integrations-item-component>
                  </div>
                  }
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </form>
  @if(selectedChannel) {
  <div class="row m-2">
    <div class="col-12 gap-2 d-flex justify-content-end pb-4">
      <button class="btn btn-outline-secondary" (click)="goBack()">
        {{ 'integrations.santriForm.cancelButton' | translate }}
      </button>

      @if(isAdmin() && !isActive) {
      <button
        class="btn btn-primary"
        type="submit"
        [disabled]="!formGroup.valid || loading"
        (click)="save()"
      >
        {{ !loading ? (isNew ? ('integrations.santriForm.saveButton' | translate) : ('integrations.santriForm.updateButton' | translate)) : "" }}
        @if (loading) {
        <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
        }
      </button>
      }
    </div>
  </div>
  }
</div>
